(function () {
  var rootSelector = '.blue-bag-klaviyo-empty-h1-fix';

  function replaceEmptyH1(root) {
    if (!root) return;
    root.querySelectorAll('h1').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text !== '') return;
      var div = document.createElement('div');
      for (var i = el.attributes.length - 1; i >= 0; i--) {
        var attr = el.attributes[i];
        div.setAttribute(attr.name, attr.value);
      }
      el.replaceWith(div);
    });
  }

  function run() {
    replaceEmptyH1(document.querySelector(rootSelector));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var root = document.querySelector(rootSelector);
  if (root) {
    new MutationObserver(run).observe(root, { childList: true, subtree: true });
  }
})();
